import { render, staticRenderFns } from "./AHFavorites.vue?vue&type=template&id=672ab308&"
import script from "./AHFavorites.vue?vue&type=script&lang=ts&"
export * from "./AHFavorites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports